import { asset_list } from "@/PageCodeComponents/MerchantAPPModelAPI/CoinAssetList";
import { coin_asset } from "./CoinAsset";
import { app_order_deposit_address } from "./AppOrderDepositAddress";
import { app_order_info } from "./AppOrderInfo ";
import { or_create_app_deposit_address } from "./OrCreateAppDepositAddress";
import { deposit_record } from "./DepositRecord";
import { deposit_record_list } from "./DepositRecordList";
import { withdraw_to_network } from "./WithdrawToNetwork";
import { withdraw_to_cwallet } from "./WithdrawToCwallet";
import { withdraw_to_record } from "./WithdrawRecord";
import { withdraw_to_record_list } from "./WithdrawRecordList";
export const codeMap: { [key: string]: any } = {
  asset_list,
  coin_asset,
  app_order_deposit_address,
  app_order_info,
  or_create_app_deposit_address,
  deposit_record,
  deposit_record_list,
  withdraw_to_network,
  withdraw_to_cwallet,
  withdraw_to_record,
  withdraw_to_record_list,
};
